import { render } from "./Translatable.vue?vue&type=template&id=12fb4a99"
import script from "./Translatable.vue?vue&type=script&lang=js"
export * from "./Translatable.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__